import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=e03a3eda&scoped=true&"
import script from "./ResourceDetail.vue?vue&type=script&lang=ts&"
export * from "./ResourceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=e03a3eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03a3eda",
  null
  
)

export default component.exports